import React, { FC, useEffect, useRef } from "react";
import classNames from "classnames";
import { SendArrowIcon } from "@/icons/primary/send-arrow";
import { DotsLoader } from "../dots-loader";

const BASE_INPUT_CLASSES = [
  "bg-gradient-bright",
  "text-sans-serif",
  "text-sm",
  "p-0.5",
  "overflow-hidden",
];

export type InputChatProps = {
  styleWrapper?: React.CSSProperties;
  placeholder?: string;
  onClick: (value: string) => void;
  onChange?: (value: string) => void;
  disabled?: boolean;
  tips?: string[];
  heightTips?: number;
  loadingTips?: boolean;
};

export const InputChat: FC<InputChatProps> = ({
  styleWrapper = {},
  placeholder,
  onClick,
  onChange,
  disabled,
  tips,
  heightTips = 220,
  loadingTips,
}) => {
  const [insideValue, setInsideValue] = React.useState<string>("");
  const [focusInput, setFocusInput] = React.useState<boolean>(false);
  const rootEl = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClick = (e: any) => {
      if (rootEl.current && !rootEl.current.contains(e.target)) {
        if (!rootEl.current.contains(e.target)) setFocusInput(false);
      }
    };

    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return (
    <div ref={rootEl} className='relative'>
      {focusInput && Array.isArray(tips) && tips.length > 0 && (
        <div
          className={`w-full border-2 bg-white border-transparent overflow-scroll rounded-sm p-5 absolute`}
          style={{ bottom: "60px", maxHeight: heightTips + "px" }}
        >
          {tips.map((tip, index) => (
            <div
              key={index}
              className='text-deep-blue text-sm py-2 px-5 border-light-neutral-2 rounded-sm hover:bg-light-purple cursor-pointer'
              style={
                tips.length !== index + 1
                  ? { borderBottomWidth: "1px", borderBottomStyle: "solid" }
                  : {}
              }
              onClick={() => {
                setFocusInput(false);
                onClick(tip);
              }}
            >
              {tip}
            </div>
          ))}
        </div>
      )}
      <div
        className={classNames([BASE_INPUT_CLASSES])}
        style={{ borderRadius: "2px", ...styleWrapper }}
      >
        <input
          className='border-transparent bg-white py-3.5 pl-5 pr-28 w-full'
          value={insideValue}
          placeholder={placeholder}
          onClick={() => setFocusInput(true)}
          onChange={(e) => {
            setInsideValue(e.target.value);
            setFocusInput(true);
            onChange && onChange(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !disabled) {
              setInsideValue("");
              onClick(insideValue);
              setFocusInput(false);
            }
          }}
          style={{ borderRadius: "2px" }}
        />

        {/* Loader */}
        {loadingTips && (
          <div className='absolute right-14 top-0 bottom-0 h-full my-auto flex items-center'>
            <DotsLoader theme='dark' />
          </div>
        )}

        <div
          className='absolute top-0 bottom-0 right-5'
          onClick={() => {
            if (!disabled) {
              setInsideValue("");
              onClick(insideValue);
            }
          }}
          style={{
            margin: "auto",
            cursor: disabled ? "not-allowed" : "pointer",
            filter: `grayscale(${disabled ? "100%" : "0"})`,
            opacity: disabled ? 0.5 : 1,
            height: "24px",
          }}
        >
          <SendArrowIcon />
        </div>
      </div>
    </div>
  );
};
